//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Faq",
  data: function () {
    return {
      quest: "",
      isOpen: false,
    };
  },

  created() {
    if (this.id === this.initOpenId) {
      this.isOpen = true;
    }
  },

  watch: {
    initOpenId() {
      if (this.id == this.initOpenId) {
        this.isOpen = true;
      }
    },
  },
  props: {
    question: {
      type: String,
      require: true,
    },
    answer: {
      type: [String, Number],
      require: true,
    },
    id: {
      type: Number,
    },

    initOpenId: {
      type: Number,
    },
  },
};
